import { borderRadius, color } from '@figma/fpl-tokens/tokens.stylex';
import * as stylex from '@stylexjs/stylex';

export const outputCardMarker = stylex.defineMarker();

export const styles = stylex.create({
  card: {
    position: 'relative',
    display: 'block',
    width: '100%',
    borderRadius: borderRadius.medium,
    overflow: 'hidden',
    backgroundColor: color.bgSecondary,
  },
  /** Caps the card's height at `maxHeight` by narrowing it to the matching width for the media's aspect ratio. */
  maxMediaHeight: (maxHeight: string, aspectRatio: number) => ({
    maxWidth: `calc(${maxHeight} * ${aspectRatio})`,
  }),
  imageTrigger: {
    display: 'block',
    width: '100%',
  },
  overlay: {
    position: 'absolute',
    pointerEvents: 'none',
  },
  visible: {
    opacity: 1,
  },
  gradient: {
    inset: 0,
    backgroundImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, transparent 100%)',
    opacity: {
      default: 0,
      [stylex.when.ancestor(':hover', outputCardMarker)]: 1,
    },
  },
  toolbar: {
    top: 12,
    left: 12,
    right: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    opacity: {
      default: 0,
      [stylex.when.ancestor(':hover', outputCardMarker)]: 1,
      [stylex.when.ancestor(':has([data-output-actions] button:focus-visible)', outputCardMarker)]: 1,
    },
  },
  title: {
    minWidth: 0,
  },
  actions: {
    display: 'flex',
    flexShrink: 0,
    gap: 4,
  },
  action: {
    display: 'flex',
    borderRadius: 4,
    backgroundColor: 'rgba(15, 15, 15, 0.5)',
  },
  interactive: {
    pointerEvents: {
      default: 'none',
      [stylex.when.ancestor(':hover', outputCardMarker)]: 'auto',
      [stylex.when.ancestor(':has([data-output-actions] button:focus-visible)', outputCardMarker)]: 'auto',
    },
  },
  interactiveVisible: {
    pointerEvents: 'auto',
  },
});
